import React from "react";
import { UiComponents, UnoStoreHooks, defaultLogo } from "@simulanisindia/ui";
import { redirectApplication } from "../../utils/general";

const { ApplicationCard: UIApplicationCard } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;



const ApplicationCard = ({ item, IsAppAssigned = true }) => {
    const userData = useUnoSelector((state) => state.user);

    return (
        <>
            <UIApplicationCard
                key={item.uuid}
                beta={false}
                showResources={false}
                showRedirectIcon={IsAppAssigned && item.origin}
                name={item.name}
                description={item.description}
                onClick={() => ((item.origin && IsAppAssigned) ? redirectApplication(userData?.token, item.origin) : null)}
                logo={item.icon || defaultLogo}
            />
        </>
    )
}

export default ApplicationCard;